import { useTranslation } from 'react-i18next';
import { plans as defaultPlans, type Plan } from '@/content/plans';
import { getUpdatedPlans } from '@/lib/stripe-pricing';
import { useQuery } from '@tanstack/react-query';
import { usePromoCode } from './use-promo-code';

interface UsePlansResult {
  plans: Plan[];
  isLoading: boolean;
  error: Error | null;
}

export function usePlans(): UsePlansResult {
  const { i18n } = useTranslation();
  const { eventCode, referralCode } = usePromoCode();

  const { data: plans = defaultPlans, isLoading: isPricesLoading, error } = useQuery({
    queryKey: ['plans', i18n.language, eventCode, referralCode],
    queryFn: () => getUpdatedPlans(defaultPlans, i18n.language, eventCode, referralCode),
    // Plans need fresh data when promo code changes
    staleTime: 0, // Always consider stale
    gcTime: 0, // Don't cache between unmounts
    refetchOnWindowFocus: false,
  });

  return {
    plans,
    isLoading: isPricesLoading,
    error: error as Error | null,
  };
}